import React, { useEffect, useState } from "react";
import { req, tr, L } from "./api";
import { BiText, Field, Check, Msg } from "./fields";

const TYPES = ["event", "workshop", "webinar", "roundtable"];
const blankEvent = () => ({ type: "event", title: L(), summary: L(), description: L(),
  startsAt: "", endsAt: "", timezone: "Asia/Dhaka", mode: "venue", venue: L(), onlineLink: "",
  capacity: 60, price: 0, registrationOpen: true, agenda: [], speakers: [], gallery: [], slides: [], published: true });

const toLocalInput = (iso) => {
  if (!iso) return "";
  try { const d = new Date(iso); const p = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`; } catch { return ""; }
};
const fromLocalInput = (v) => (v ? new Date(v).toISOString() : "");

export default function EventsAdmin({ canEdit }) {
  const [items, setItems] = useState(null);
  const [edit, setEdit] = useState(null);
  const [draft, setDraft] = useState(null);
  const [regs, setRegs] = useState(null); // {eventId, rows}
  const [msg, setMsg] = useState("");

  const load = () => req("/admin/events").then((r) => setItems(r.sort((a, b) => String(b.startsAt).localeCompare(String(a.startsAt))))).catch((e) => setMsg(e.message));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (edit === "new") await req("/admin/events", { method: "POST", body: draft });
      else await req(`/admin/events/${edit}`, { method: "PUT", body: draft });
      setMsg("Saved."); setEdit(null); setDraft(null); load();
    } catch (x) { setMsg("Could not save: " + x.message); }
  };
  const del = async (id) => {
    if (!window.confirm("Delete this event and keep its registrations? ")) return;
    try { await req(`/admin/events/${id}`, { method: "DELETE" }); setMsg("Deleted."); load(); } catch (x) { setMsg("Could not delete: " + x.message); }
  };
  const showRegs = async (id) => {
    const rows = await req(`/admin/registrations?eventId=${id}`);
    setRegs({ eventId: id, rows });
  };
  const setRegStatus = async (rid, status) => {
    await req(`/admin/registrations/${rid}`, { method: "PUT", body: { status } });
    showRegs(regs.eventId);
  };

  if (edit) {
    const d = draft;
    const up = (k, v) => setDraft({ ...d, [k]: v });
    const upAgenda = (i, k, v) => { const a = [...d.agenda]; a[i] = { ...a[i], [k]: v }; up("agenda", a); };
    const upSp = (i, k, v) => { const s = [...d.speakers]; s[i] = { ...s[i], [k]: v }; up("speakers", s); };
    return (
      <form className="form" onSubmit={save} data-testid="event-edit-form">
        <Msg msg={msg} />
        <div className="grp">Event</div>
        <Field label="Type"><select value={d.type} onChange={(e) => up("type", e.target.value)} data-testid="event-type">{TYPES.map((t) => <option key={t} value={t}>{t}</option>)}</select></Field>
        <Field label="Mode"><select value={d.mode} onChange={(e) => up("mode", e.target.value)}><option value="venue">At a venue</option><option value="online">Online</option></select></Field>
        <BiText label="Title" value={d.title} onChange={(v) => up("title", v)} />
        <BiText label="Summary" value={d.summary} onChange={(v) => up("summary", v)} area />
        <BiText label="Description (optional)" value={d.description} onChange={(v) => up("description", v)} area />
        <Field label="Starts (your local time)"><input type="datetime-local" value={toLocalInput(d.startsAt)} onChange={(e) => up("startsAt", fromLocalInput(e.target.value))} data-testid="event-starts" /></Field>
        <Field label="Ends"><input type="datetime-local" value={toLocalInput(d.endsAt)} onChange={(e) => up("endsAt", fromLocalInput(e.target.value))} /></Field>
        {d.mode === "venue" ? <BiText label="Venue" value={d.venue} onChange={(v) => up("venue", v)} />
          : <Field label="Online link (emailed to guests)"><input value={d.onlineLink || ""} onChange={(e) => up("onlineLink", e.target.value)} /></Field>}
        <Field label="Capacity (0 = unlimited)"><input type="number" value={d.capacity || 0} onChange={(e) => up("capacity", Number(e.target.value))} /></Field>
        <Field label="Price in BDT (0 = free)"><input type="number" value={d.price || 0} onChange={(e) => up("price", Number(e.target.value))} /></Field>
        <Check label="Registration open" checked={d.registrationOpen !== false} onChange={(v) => up("registrationOpen", v)} testid="event-reg-open" />
        <Check label="Published on the site" checked={d.published !== false} onChange={(v) => up("published", v)} testid="event-published" />
        <div className="grp">Agenda</div>
        {(d.agenda || []).map((a, i) => (
          <React.Fragment key={i}>
            <Field label={`Item ${i + 1} — time`}><input value={a.time || ""} onChange={(e) => upAgenda(i, "time", e.target.value)} placeholder="15:00" /></Field>
            <BiText label={`Item ${i + 1}`} value={a.item} onChange={(v) => upAgenda(i, "item", v)} />
            <div className="row-actions" style={{ gridColumn: "1/-1" }}><button type="button" className="btn sm ghost danger" onClick={() => up("agenda", d.agenda.filter((_, j) => j !== i))}>Remove</button></div>
          </React.Fragment>))}
        <div className="row-actions" style={{ gridColumn: "1/-1" }}><button type="button" className="btn sm ghost" onClick={() => up("agenda", [...(d.agenda || []), { time: "", item: L() }])}>Add agenda item</button></div>
        <div className="grp">Speakers</div>
        {(d.speakers || []).map((s, i) => (
          <React.Fragment key={i}>
            <Field label={`Speaker ${i + 1} — name`}><input value={s.name || ""} onChange={(e) => upSp(i, "name", e.target.value)} /></Field>
            <BiText label={`Speaker ${i + 1} — role`} value={s.role} onChange={(v) => upSp(i, "role", v)} />
            <div className="row-actions" style={{ gridColumn: "1/-1" }}><button type="button" className="btn sm ghost danger" onClick={() => up("speakers", d.speakers.filter((_, j) => j !== i))}>Remove</button></div>
          </React.Fragment>))}
        <div className="row-actions" style={{ gridColumn: "1/-1" }}><button type="button" className="btn sm ghost" onClick={() => up("speakers", [...(d.speakers || []), { name: "", role: L() }])}>Add speaker</button></div>
        <div className="grp">After the event</div>
        <Field label="Gallery image URLs (one per line)" full><textarea rows={3} value={(d.gallery || []).join("\n")} onChange={(e) => up("gallery", e.target.value.split("\n").map((x) => x.trim()).filter(Boolean))} /></Field>
        <div className="row-actions" style={{ gridColumn: "1/-1" }}>
          <button type="submit" className="btn" data-testid="event-save">Save event</button>
          <button type="button" className="btn ghost" onClick={() => { setEdit(null); setDraft(null); }}>Cancel</button>
        </div>
      </form>
    );
  }

  if (!items) return <p className="muted">Loading…</p>;
  return (
    <div>
      <Msg msg={msg} />
      {canEdit && <div className="row-actions" style={{ marginBottom: 18 }}><button className="btn sm" onClick={() => { setEdit("new"); setDraft(blankEvent()); }} data-testid="event-new">Add an event</button></div>}
      {items.length ? (
        <div className="tbl-wrap"><table className="tbl" data-testid="events-table">
          <thead><tr><th>Event</th><th>Type</th><th>Starts</th><th>Registration</th><th></th></tr></thead>
          <tbody>{items.map((x) => (
            <React.Fragment key={x.id}>
              <tr>
                <td><strong>{tr(x.title)}</strong>{!tr(x.title, "bn") && <div className="bn-miss">Bangla missing</div>}</td>
                <td><span className="pill">{x.type}</span></td>
                <td className="num">{x.startsAt ? new Date(x.startsAt).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—"}</td>
                <td><span className={`pill${x.registrationOpen !== false ? " on" : ""}`}>{x.registrationOpen !== false ? "Open" : "Closed"}</span>{x.published === false && <span className="pill">Draft</span>}</td>
                <td><div className="row-actions">
                  <button className="btn sm ghost" onClick={() => showRegs(x.id)} data-testid={`event-regs-${x.id}`}>Registrations</button>
                  <a className="btn sm ghost" href={`/api/admin/events/${x.id}/registrations.csv`} data-testid={`event-csv-${x.id}`}>CSV</a>
                  {canEdit && <button className="btn sm ghost" onClick={() => { setEdit(x.id); setDraft(JSON.parse(JSON.stringify(x))); }} data-testid={`event-edit-${x.id}`}>Edit</button>}
                  {canEdit && <button className="btn sm ghost danger" onClick={() => del(x.id)}>Delete</button>}
                </div></td>
              </tr>
              {regs && regs.eventId === x.id && (
                <tr><td colSpan={5} style={{ background: "var(--tint)" }}>
                  {regs.rows.length ? (
                    <table className="tbl"><thead><tr><th>Name</th><th>Organisation</th><th>Email</th><th>Attendees</th><th>Status</th></tr></thead>
                      <tbody>{regs.rows.map((r) => (
                        <tr key={r.id}><td>{r.name}</td><td>{r.org}</td><td>{r.email}</td><td className="num">{r.attendees}</td>
                          <td><select value={r.status} onChange={(e) => setRegStatus(r.id, e.target.value)} disabled={!canEdit} data-testid={`reg-status-${r.id}`}>
                            {["registered", "waitlisted", "cancelled", "attended"].map((s) => <option key={s} value={s}>{s}</option>)}
                          </select></td></tr>))}</tbody></table>
                  ) : <div className="empty">No registrations yet.</div>}
                </td></tr>)}
            </React.Fragment>))}</tbody></table></div>
      ) : <div className="empty">No events yet.</div>}
    </div>
  );
}
